// Auto-generated from nom_officiel_wilayas_communes.xlsx
// Standardized Official French Names for Logistics Compatibility

export interface OfficialWilaya {
  code: string;
  name: string;
}

export const OFFICIAL_WILAYAS: OfficialWilaya[] = [
  { code: "1", name: "Adrar" },
  { code: "2", name: "Chlef" },
  { code: "3", name: "Laghouat" },
  { code: "4", name: "Oum El Bouaghi" },
  { code: "5", name: "Batna" },
  { code: "6", name: "Béjaïa" },
  { code: "7", name: "Biskra" },
  { code: "8", name: "Béchar" },
  { code: "9", name: "Blida" },
  { code: "10", name: "Bouira" },
  { code: "11", name: "Tamanrasset" },
  { code: "12", name: "Tébessa" },
  { code: "13", name: "Tlemcen" },
  { code: "14", name: "Tiaret" },
  { code: "15", name: "Tizi Ouzou" },
  { code: "16", name: "Alger" },
  { code: "17", name: "Djelfa" },
  { code: "18", name: "Jijel" },
  { code: "19", name: "Sétif" },
  { code: "20", name: "Saïda" },
  { code: "21", name: "Skikda" },
  { code: "22", name: "Sidi Bel Abbès" },
  { code: "23", name: "Annaba" },
  { code: "24", name: "Guelma" },
  { code: "25", name: "Constantine" },
  { code: "26", name: "Médéa" },
  { code: "27", name: "Mostaganem" },
  { code: "28", name: "M'Sila" },
  { code: "29", name: "Mascara" },
  { code: "30", name: "Ouargla" },
  { code: "31", name: "Oran" },
  { code: "32", name: "El Bayadh" },
  { code: "33", name: "Illizi" },
  { code: "34", name: "Bordj Bou Arreridj" },
  { code: "35", name: "Boumerdès" },
  { code: "36", name: "El Tarf" },
  { code: "37", name: "Tindouf" },
  { code: "38", name: "Tissemsilt" },
  { code: "39", name: "El Oued" },
  { code: "40", name: "Khenchela" },
  { code: "41", name: "Souk Ahras" },
  { code: "42", name: "Tipaza" },
  { code: "43", name: "Mila" },
  { code: "44", name: "Aïn Defla" },
  { code: "45", name: "Naâma" },
  { code: "46", name: "Aïn Témouchent" },
  { code: "47", name: "Ghardaïa" },
  { code: "48", name: "Relizane" },
  { code: "49", name: "Timimoun" },
  { code: "50", name: "Bordj Badji Mokhtar" },
  { code: "51", name: "Ouled Djellal" },
  { code: "52", name: "Béni Abbès" },
  { code: "53", name: "In Salah" },
  { code: "54", name: "In Guezzam" },
  { code: "55", name: "Touggourt" },
  { code: "56", name: "Djanet" },
  { code: "57", name: "El M'Ghair" },
  { code: "58", name: "El Menia" },
];

export const OFFICIAL_COMMUNES: Record<string, string[]> = {
  "1": [
    "Adrar",
    "Akabli",
    "Aoulef",
    "Bouda",
    "Fenoughil",
    "In Zghmir",
    "Ouled Ahmed Tammi",
    "Reggane",
    "Sali",
    "Sebaa",
    "Tamantit",
    "Tamekten",
    "Tamest",
    "Tit",
    "Tsabit",
    "Zaouiet Kounta",
  ],
  "2": [
    "Abou El Hassan",
    "Aïn Merane",
    "Beni Bouateb",
    "Beni Haoua",
    "Beni Rached",
    "Boukadir",
    "Bouzeghaia",
    "Breira",
    "Bénairia",
    "Chettia",
    "Chlef",
    "Dahra",
    "El Hadjadj",
    "El Karimia",
    "El Marsa",
    "Harchoun",
    "Harenfa",
    "Labiod Medjadja",
    "Moussadek",
    "Oued Fodda",
    "Oued Goussine",
    "Oued Sly",
    "Ouled Abbes",
    "Ouled Ben Abdelkader",
    "Ouled Fares",
    "Oum Drou",
    "Sendjas",
    "Sidi Abderrahmane",
    "Sidi Akkacha",
    "Sobha",
    "Tadjena",
    "Talassa",
    "Taougrite",
    "Ténès",
    "Zeboudja",
  ],
  "3": [
    "Aflou",
    "Aïn Madhi",
    "Aïn Sidi Ali",
    "Beidha",
    "Bennasser Benchohra",
    "Brida",
    "El Assafia",
    "El Ghicha",
    "El Houaita",
    "Gueltat Sidi Saad",
    "Hadj Mechri",
    "Hassi Delaa",
    "Hassi R'Mel",
    "Kheneg",
    "Ksar El Hirane",
    "Laghouat",
    "Oued M'Zi",
    "Oued Morra",
    "Sebgag",
    "Sidi Bouzid",
    "Sidi Makhlouf",
    "Tadjemout",
    "Tadjrouna",
    "Taouiala",
  ],
  "4": [
    "Aïn Babouche",
    "Aïn Beïda",
    "Aïn Diss",
    "Aïn Fakroun",
    "Aïn Kercha",
    "Aïn M'lila",
    "Aïn Zitoun",
    "Behir Chergui",
    "Berriche",
    "Bir Chouhada",
    "Dhalaa",
    "El Amiria",
    "El Belala",
    "El Djazia",
    "El Fedjoudj Boughrara Saoudi",
    "El Harmilia",
    "Fkirina",
    "Hanchir Toumghani",
    "Ksar Sbahi",
    "Meskiana",
    "Oued Nini",
    "Ouled Gacem",
    "Ouled Hamla",
    "Ouled Zouaï",
    "Oum el Bouaghi",
    "Rahia",
    "Sigus",
    "Souk Naamane",
    "Zorg",
  ],
  "5": [
    "Abdelkader Azil",
    "Arris",
    "Aïn Djasser",
    "Aïn Touta",
    "Aïn Yagout",
    "Barika",
    "Batna",
    "Ben Foudhala El Hakania",
    "Bitam",
    "Boulhilat",
    "Boumagueur",
    "Boumia (Batna)",
    "Bouzina",
    "Chemora",
    "Chir",
    "Djerma",
    "Djezar",
    "El Hassi",
    "El Madher",
    "Fesdis",
    "Foum Toub",
    "Ghassira",
    "Gosbat",
    "Guigba",
    "Hidoussa",
    "Ichmoul",
    "Inoughissen",
    "Kimmel",
    "Ksar Bellezma",
    "Larbaâ",
    "Lazrou",
    "Lemsane",
    "M'doukel",
    "Maafa",
    "Menaa",
    "Merouana",
    "N'Gaous",
    "Oued Chaaba",
    "Oued El Ma",
    "Oued Taga",
    "Ouled Ammar",
    "Ouled Aouf",
    "Ouled Fadel",
    "Ouled Sellam",
    "Ouled Si Slimane",
    "Ouyoun El Assafir",
    "Rahbat",
    "Ras El Aioun",
    "Sefiane",
    "Seggana",
    "Seriana",
    "T'Kout",
    "Talkhamt",
    "Taxlent",
    "Tazoult",
    "Teniet El Abed",
    "Tighanimine",
    "Tigherghar",
    "Tilatou",
    "Timgad",
    "Zanat El Beida",
  ],
  "6": [
    "Adekar",
    "Ait Djellil",
    "Akbou",
    "Akfadou",
    "Amalou",
    "Amizour",
    "Aokas",
    "Aït Ksila",
    "Aït Maouche",
    "Aït Mellikeche",
    "Aït R'zine",
    "Aït Smail",
    "Barbacha",
    "Boudjellil",
    "Bouhamza",
    "Boukhelifa",
    "Béjaïa",
    "Chellata",
    "Chemini",
    "Darguina",
    "Draâ El Kaïd",
    "El Kseur",
    "Fenaïa Ilmaten",
    "Ferraoun",
    "Ighil Ali",
    "Ighram",
    "Kendira",
    "Kherrata",
    "Leflaye",
    "M'cisna",
    "Melbou",
    "Oued Ghir",
    "Ouzellaguen",
    "Seddouk",
    "Semaoun",
    "Sidi Ayad",
    "Sidi Aïch",
    "Souk El Ténine",
    "Souk Oufella",
    "Tala Hamza",
    "Tamokra",
    "Tamridjet",
    "Taourirt Ighil",
    "Taskriout",
    "Tazmalt",
    "Tibane",
    "Tichy",
    "Tifra",
    "Timezrit",
    "Tinabdher",
    "Tizi N'Berber",
    "Toudja",
  ],
  "7": [
    "Aïn Naga",
    "Aïn Zaatout",
    "Biskra",
    "Bordj Ben Azzouz",
    "Bouchagroune",
    "Branis",
    "Chetma",
    "Djemorah",
    "El Feidh",
    "El Ghrous",
    "El Hadjeb",
    "El Haouch",
    "El Kantara",
    "El Mizaraa",
    "El Outaya",
    "Foughala",
    "Khenguet Sidi Nadji",
    "Lichana",
    "Lioua",
    "M'Chouneche",
    "M'Lili",
    "Mekhadma",
    "Oumache",
    "Ourlal",
    "Sidi Okba",
    "Tolga",
    "Zeribet El Oued",
  ],
  "8": [
    "Abadla",
    "Beni Ounif",
    "Boukais",
    "Béchar",
    "Erg Ferradj",
    "Kenadsa",
    "Lahmar",
    "Mechraa Houari Boumedienne",
    "Meridja",
    "Mougheul",
    "Taghit",
  ],
  "9": [
    "Aïn Romana",
    "Beni Mered",
    "Beni Tamou",
    "Benkhelil",
    "Blida",
    "Bouarfa",
    "Boufarik",
    "Bougara",
    "Bouinan",
    "Chebli",
    "Chiffa",
    "Chréa",
    "Djebabra",
    "El Affroun",
    "Guerouaou",
    "Hammam Melouane",
    "Larbaa",
    "Meftah",
    "Mouzaia",
    "Oued Alleug",
    "Oued Djer",
    "Ouled Slama",
    "Ouled Yaïch",
    "Souhane",
    "Soumaa",
  ],
  "10": [
    "Aghbalou",
    "Ahl El Ksar",
    "Aomar",
    "Ath Mansour",
    "Aïn Bessem",
    "Aïn El Hadjar",
    "Aïn El Turc",
    "Aïn Laloui",
    "Aït Laziz",
    "Bechloul",
    "Bir Ghbalou",
    "Bordj Okhriss",
    "Bouderbala",
    "Bouira",
    "Boukram",
    "Chorfa",
    "Dechmia",
    "Dirrah",
    "Djebahia",
    "El Adjiba",
    "El Asnam",
    "El Hachimia",
    "El Hakimia",
    "El Khabouzia",
    "El Mokrani",
    "Guerrouma",
    "Hadjera Zerga",
    "Haizer",
    "Hanif",
    "Kadiria",
    "Lakhdaria",
    "M'Chedallah",
    "Maala",
    "Maamora",
    "Mezdour",
    "Oued El Berdi",
    "Ouled Rached",
    "Raouraoua",
    "Ridane",
    "Saharidj",
    "Souk El Khemis",
    "Sour El Ghouzlane",
    "Taghzout",
    "Taguedit",
    "Zbarbar",
  ],
  "11": [
    "Abalessa",
    "Idles",
    "In Amguel",
    "Tamanrasset",
    "Tazrouk",
  ],
  "12": [
    "Aïn Zerga",
    "Bedjene",
    "Bekkaria",
    "Bir Dheb",
    "Bir Mokkadem",
    "Bir el Ater",
    "Boukhadra",
    "Boulhaf Dir",
    "Cheria",
    "El Aouinet",
    "El Houidjbet",
    "El Kouif",
    "El Ma Labiodh",
    "El Meridj",
    "El Mezeraa",
    "El Ogla",
    "Ferkane",
    "Guorriguer",
    "Hammamet",
    "Morsott",
    "Negrine",
    "Ogla Melha",
    "Ouenza",
    "Oum Ali",
    "Safsaf El Ouesra",
    "Stah Guentis",
    "Tlidjene",
    "Tébessa",
  ],
  "13": [
    "Amieur",
    "Azails",
    "Aïn Fetah",
    "Aïn Fezza",
    "Aïn Ghoraba",
    "Aïn Kebira",
    "Aïn Nehala",
    "Aïn Tallout",
    "Aïn Youcef",
    "Bab El Assa",
    "Beni Bahdel",
    "Beni Boussaid",
    "Beni Khellad",
    "Beni Mester",
    "Beni Ouarsous",
    "Beni Semiel",
    "Beni Snous",
    "Bensekrane",
    "Bouhlou",
    "Chetouane",
    "Dar Yaghmouracene",
    "Djebala",
    "El Aricha",
    "El Bouihi",
    "El Fehoul",
    "El Gor",
    "Fellaoucene",
    "Ghazaouet",
    "Hammam Boughrara",
    "Hennaya",
    "Honaïne",
    "MSirda Fouaga",
    "Maghnia",
    "Mansourah",
    "Marsa Ben M'Hidi",
    "Nedroma",
    "Oued Lakhdar",
    "Ouled Mimoun",
    "Ouled Riyah",
    "Remchi",
    "Sabra",
    "Sebaa Chioukh",
    "Sebdou",
    "Sidi Abdelli",
    "Sidi Djillali",
    "Sidi Medjahed",
    "Souahlia",
    "Souani",
    "Souk Tlata",
    "Terny Beni Hdiel",
    "Tienet",
    "Tlemcen",
    "Zenata",
  ],
  "14": [
    "Aïn Bouchekif",
    "Aïn Deheb",
    "Aïn Dzarit",
    "Aïn El Hadid",
    "Aïn Kermes",
    "Bougara",
    "Chehaima",
    "Dahmouni",
    "Djebilet Rosfa",
    "Djillali Ben Amar",
    "Faidja",
    "Frenda",
    "Guertoufa",
    "Hamadia",
    "Ksar Chellala",
    "Madna",
    "Mahdia",
    "Mechraa Safa",
    "Medrissa",
    "Medroussa",
    "Meghila",
    "Mellakou",
    "Nadorah",
    "Naima",
    "Oued Lilli",
    "Rahouia",
    "Rechaiga",
    "Sebaine",
    "Sebt",
    "Serghine",
    "Si Abdelghani",
    "Sidi Abderahmane",
    "Sidi Ali Mellal",
    "Sidi Bakhti",
    "Sidi Hosni",
    "Sougueur",
    "Tagdemt",
    "Takhemaret",
    "Tiaret",
    "Tidda",
    "Tousnina",
    "Zmalet El Emir Abdelkader",
  ],
  "15": [
    "Abi Youcef",
    "Aghribs",
    "Agouni Gueghrane",
    "Ain El Hammam",
    "Akbil",
    "Akerrou",
    "Assi Youcef",
    "Ath Zikki",
    "Azazga",
    "Azeffoun",
    "Aïn Zaouia",
    "Aït Aggouacha",
    "Aït Aïssa Mimoun",
    "Aït Bouadou",
    "Aït Boumahdi",
    "Aït Chafâa",
    "Aït Khellili",
    "Aït Mahmoud",
    "Aït Oumalou",
    "Aït Toudert",
    "Aït Yahia",
    "Aït Yahia Moussa",
    "Aït Yenni",
    "Beni Aïssi",
    "Beni Douala",
    "Beni Zmenzer",
    "Boghni",
    "Boudjima",
    "Bounouh",
    "Bouzguen",
    "Draâ Ben Khedda",
    "Draâ El Mizan",
    "Freha",
    "Frikat",
    "Iboudraren",
    "Idjeur",
    "Iferhounène",
    "Ifigha",
    "Iflissen",
    "Illilten",
    "Illoula Oumalou",
    "Imsouhel",
    "Irdjen",
    "Larbaâ Nath Irathen",
    "M'Kira",
    "Makouda",
    "Mechtras",
    "Mekla",
    "Mizrana",
    "Mâatkas",
    "Ouacif",
    "Ouadhia",
    "Ouaguenoun",
    "Sidi Namane",
    "Souamaâ",
    "Souk El Thenine",
    "Tadmaït",
    "Tigzirt",
    "Timizart",
    "Tirmitine",
    "Tizi Gheniff",
    "Tizi N'Tleta",
    "Tizi Ouzou",
    "Tizi Rached",
    "Yakouren",
    "Yatafen",
    "Zekri",
  ],
  "16": [
    "Alger Centre",
    "Aïn Benian",
    "Aïn Taya",
    "Bab El Oued",
    "Bab Ezzouar",
    "Baba Hassen",
    "Bachdjerrah",
    "Baraki",
    "Belouizdad",
    "Ben Aknoun",
    "Beni Messous",
    "Bir Mourad Raïs",
    "Birkhadem",
    "Birtouta",
    "Bologhine",
    "Bordj El Bahri",
    "Bordj El Kiffan",
    "Bourouba",
    "Bouzareah",
    "Casbah",
    "Cheraga",
    "Dar El Beïda",
    "Dely Ibrahim",
    "Djasr Kasentina",
    "Douera",
    "Draria",
    "El Achour",
    "El Biar",
    "El Hammamet",
    "El Harrach",
    "El Madania",
    "El Magharia",
    "El Marsa",
    "El Mouradia",
    "H'raoua",
    "Hussein Dey",
    "Hydra",
    "Khraicia",
    "Kouba",
    "Les Eucalyptus",
    "Mahelma",
    "Mohammadia",
    "Oued Koriche",
    "Oued Smar",
    "Ouled Chebel",
    "Ouled Fayet",
    "Rahmania",
    "Raïs Hamidou",
    "Reghaïa",
    "Rouïba",
    "Saoula",
    "Sidi M'Hamed",
    "Sidi Moussa",
    "Souidania",
    "Staoueli",
    "Tessala El Merdja",
    "Zeralda",
  ],
  "17": [
    "Amourah",
    "Aïn Chouhada",
    "Aïn El Ibel",
    "Aïn Feka",
    "Aïn Maabed",
    "Aïn Oussara",
    "Benhar",
    "Beni Yagoub",
    "Birine",
    "Bouira Lahdab",
    "Charef",
    "Dar Chioukh",
    "Deldoul",
    "Djelfa",
    "Douis",
    "El Guedid",
    "El Idrissia",
    "El Khemis",
    "Faidh El Botma",
    "Guernini",
    "Guettara",
    "Had Sahary",
    "Hassi Bahbah",
    "Hassi El Euch",
    "Hassi Fedoul",
    "M'Liliha",
    "Messaad",
    "Moudjebara",
    "Oum Laadham",
    "Sed Rahal",
    "Selmana",
    "Sidi Baizid",
    "Sidi Ladjel",
    "Tadmit",
    "Zaafrane",
    "Zaccar",
  ],
  "18": [
    "Bordj Tahar",
    "Boucif Ouled Askeur",
    "Boudriaa Ben Yadjis",
    "Bouraoui Belhadef",
    "Chahna",
    "Chekfa",
    "Djemaa Beni Habibi",
    "Djimla",
    "El Ancer",
    "El Aouana",
    "El Kennar Nouchfi",
    "El Milia",
    "Emir Abdelkader",
    "Eraguene",
    "Ghebala",
    "Jijel",
    "Kaous",
    "Kheïri Oued Adjoul",
    "Ouadjana",
    "Ouled Rabah",
    "Ouled Yahia Khedrouche",
    "Selma Benziada",
    "Settara",
    "Sidi Abdelaziz",
    "Sidi Maarouf",
    "Taher",
    "Texenna",
    "Ziama Mansouriah",
  ],
  "19": [
    "Amoucha",
    "Aïn Abessa",
    "Aïn Arnat",
    "Aïn Azel",
    "Aïn El Kebira",
    "Aïn Lahdjar",
    "Aïn Legradj",
    "Aïn Oulmene",
    "Aïn Roua",
    "Aïn Sebt",
    "Aït Naoual Mezada",
    "Aït Tizi",
    "Aït Wertilan",
    "Babor",
    "Bazer Sakhra",
    "Beidha Bordj",
    "Belaa",
    "Beni Aziz",
    "Beni Chebana",
    "Beni Fouda",
    "Beni Hocine",
    "Beni Mouhli",
    "Bir El Arch",
    "Bir Haddada",
    "Bouandas",
    "Bougaa",
    "Bousselam",
    "Boutaleb",
    "Dehamcha",
    "Djemila",
    "Draa Kebila",
    "El Eulma",
    "El Ouldja",
    "El Ouricia",
    "Guellal",
    "Guelta Zerka",
    "Guenzet",
    "Guidjel",
    "Hamma",
    "Hammam Guergour",
    "Hammam Soukhna",
    "Harbil",
    "Ksar El Abtal",
    "Maaouia",
    "Maoklane",
    "Mezloug",
    "Oued El Barad",
    "Ouled Addouane",
    "Ouled Sabor",
    "Ouled Si Ahmed",
    "Ouled Tebben",
    "Rasfa",
    "Salah Bey",
    "Serdj El Ghoul",
    "Sétif",
    "Tachouda",
    "Talaifacene",
    "Taya",
    "Tella",
    "Tizi N'Bechar",
  ],
  "20": [
    "Aïn El Hadjar",
    "Aïn Sekhouna",
    "Aïn Soltane",
    "Doui Thabet",
    "El Hassasna",
    "Hounet",
    "Maamora",
    "Moulay Larbi",
    "Ouled Brahim",
    "Ouled Khaled",
    "Saïda",
    "Sidi Ahmed",
    "Sidi Amar",
    "Sidi Boubekeur",
    "Tircine",
    "Youb",
  ],
  "21": [
    "Azzaba",
    "Aïn Bouziane",
    "Aïn Charchar",
    "Aïn Kechra",
    "Aïn Zouit",
    "Bekkouche Lakhdar",
    "Ben Azzouz",
    "Beni Bechir",
    "Beni Oulbane",
    "Beni Zid",
    "Bin El Ouiden",
    "Bouchtata",
    "Cheraia",
    "Collo",
    "Djendel Saadi Mohamed",
    "El Ghedir",
    "El Hadaiek",
    "El Harrouch",
    "El Marsa",
    "Emdjez Edchich",
    "Es Sebt",
    "Filfila",
    "Hamadi Krouma",
    "Kanoua",
    "Kerkera",
    "Kheneg Mayoum",
    "Oued Zehour",
    "Ouldja Boulballout",
    "Ouled Attia",
    "Ouled Hbaba",
    "Oum Toub",
    "Ramdane Djamel",
    "Salah Bouchaour",
    "Sidi Mezghiche",
    "Skikda",
    "Tamalous",
    "Zerdaza",
    "Zitouna",
  ],
  "22": [
    "Amarnas",
    "Aïn Adden",
    "Aïn El Berd",
    "Aïn Kada",
    "Aïn Thrid",
    "Aïn Tindamine",
    "Badredine El Mokrani",
    "Belarbi",
    "Ben Badis",
    "Benachiba Chelia",
    "Bir El Hammam",
    "Boudjebaa El Bordj",
    "Boukhanafis",
    "Chettouane Belaila",
    "Dhaya",
    "El Haçaiba",
    "Hassi Dahou",
    "Hassi Zehana",
    "Lamtar",
    "M'Cid",
    "Makedra",
    "Marhoum",
    "Merine",
    "Mezaourou",
    "Mostefa Ben Brahim",
    "Moulay Slissen",
    "Oued Sebaa",
    "Oued Sefioun",
    "Oued Taourira",
    "Ras El Ma",
    "Redjem Demouche",
    "Sehala Thaoura",
    "Sfisef",
    "Sidi Ali Benyoub",
    "Sidi Ali Boussidi",
    "Sidi Bel Abbes",
    "Sidi Brahim",
    "Sidi Chaib",
    "Sidi Daho des Zairs",
    "Sidi Hamadouche",
    "Sidi Khaled",
    "Sidi Lahcene",
    "Sidi Yacoub",
    "Tabia",
    "Tafissour",
    "Taoudmout",
    "Teghalimet",
    "Telagh",
    "Tenira",
    "Tessala",
    "Tilmouni",
    "Zerouala",
  ],
  "23": [
    "Annaba",
    "Aïn Berda",
    "Berrahal",
    "Chetaïbi",
    "Cheurfa",
    "El Bouni",
    "El Hadjar",
    "Eulma",
    "Oued El Aneb",
    "Seraïdi",
    "Sidi Amar",
    "Treat",
  ],
  "24": [
    "Aïn Ben Beida",
    "Aïn Larbi",
    "Aïn Makhlouf",
    "Aïn Reggada",
    "Aïn Sandel",
    "Belkheir",
    "Ben Djerrah",
    "Beni Mezline",
    "Bordj Sabath",
    "Bouati Mahmoud",
    "Bouchegouf",
    "Bouhachana",
    "Bouhamdane",
    "Boumahra Ahmed",
    "Dahouara",
    "Djeballah Khemissi",
    "El Fedjoudj",
    "Guellat Bou Sbaa",
    "Guelma",
    "Hammam Debagh",
    "Hammam N'Bail",
    "Houari Boumédiène",
    "Héliopolis",
    "Khezarra",
    "Medjez Amar",
    "Medjez Sfa",
    "Nechmaya",
    "Oued Cheham",
    "Oued Fragha",
    "Oued Zenati",
    "Ras El Agba",
    "Roknia",
    "Sellaoua Announa",
    "Tamlouka",
  ],
  "25": [
    "Aïn Abid",
    "Aïn Smara",
    "Beni Hamiden",
    "Constantine",
    "Didouche Mourad",
    "El Khroub",
    "Hamma Bouziane",
    "Ibn Badis",
    "Ibn Ziad",
    "Messaoud Boudjriou",
    "Ouled Rahmoune",
    "Zighoud Youcef",
  ],
  "26": [
    "Aissaouia",
    "Aziz",
    "Aïn Boucif",
    "Aïn Ouksir",
    "Baata",
    "Benchicao",
    "Beni Slimane",
    "Berrouaghia",
    "Bir Ben Laabed",
    "Boghar",
    "Bou Aiche",
    "Bouaichoune",
    "Bouchrahil",
    "Boughezoul",
    "Bouskene",
    "Chahbounia",
    "Chellalet El Adhaoura",
    "Cheniguel",
    "Derrag",
    "Deux Bassins",
    "Djouab",
    "Draa Essamar",
    "El Azizia",
    "El Guelb El Kebir",
    "El Hamdania",
    "El Omaria",
    "El Ouinet",
    "Hannacha",
    "Kef Lakhdar",
    "Khams Djouamaa",
    "Ksar Boukhari",
    "Meftaha",
    "Meghraoua",
    "Mezerana",
    "Mihoub",
    "Moudjbar",
    "Médéa",
    "Ouamri",
    "Oued Harbil",
    "Ouled Antar",
    "Ouled Bouachra",
    "Ouled Brahim",
    "Ouled Deide",
    "Ouled Hellal",
    "Ouled Maaref",
    "Oum El Djalil",
    "Ouzera",
    "Rebaia",
    "Saneg",
    "Sedraia",
    "Seghouane",
    "Si Mahdjoub",
    "Sidi Damed",
    "Sidi Errabia",
    "Sidi Naamanez",
    "Sidi Zahar",
    "Sidi Ziane",
    "Souagui",
    "Tablat",
    "Tafraout",
    "Tamesguida",
    "Tizi Mahdi",
    "Tlatet Eddouar",
    "Zoubiria",
  ],
  "27": [
    "Abdelmalek Ramdane",
    "Achaacha",
    "Aïn Boudinar",
    "Aïn Nouissy",
    "Aïn Sidi Cherif",
    "Aïn Tedles",
    "Blad Touahria",
    "Bouguirat",
    "El Hassaine",
    "Fornaka",
    "Hadjadj",
    "Hassi Mameche",
    "Khadra",
    "Kheireddine",
    "Mansourah",
    "Mazagran",
    "Mesra",
    "Mostaganem",
    "Nekmaria",
    "Oued El Kheir",
    "Ouled Boughalem",
    "Ouled Maallah",
    "Safsaf",
    "Sayada",
    "Sidi Ali",
    "Sidi Belattar",
    "Sidi Lakhdar",
    "Sirat",
    "Souaflia",
    "Sour",
    "Stidia",
    "Tazgait",
  ],
  "28": [
    "Aïn El Hadjel",
    "Aïn El Melh",
    "Aïn Errich",
    "Aïn Fares",
    "Aïn Khadra",
    "Belaiba",
    "Ben Srour",
    "Beni Ilmane",
    "Benzouh",
    "Berhoum",
    "Bir Foda",
    "Bou Saâda",
    "Bouti Sayah",
    "Chellal",
    "Dehahna",
    "Djebel Messaad",
    "El Hamel",
    "El Houamed",
    "Hammam Dhalaa",
    "Khettouti Sed El Djir",
    "Khoubana",
    "M'Cif",
    "M'Sila",
    "M'Tarfa",
    "Maadid",
    "Maarif",
    "Magra",
    "Medjedel",
    "Mohammed Boudiaf",
    "Ouanougha",
    "Ouled Addi Guebala",
    "Ouled Atia",
    "Ouled Derradj",
    "Ouled Madhi",
    "Ouled Mansour",
    "Ouled Sidi Brahim",
    "Ouled Slimane",
    "Oultem",
    "Sidi Ameur",
    "Sidi Aïssa",
    "Sidi Hadjeres",
    "Sidi M'Hamed",
    "Slim",
    "Souamaa",
    "Tamsa",
    "Tarmount",
    "Zarzour",
  ],
  "29": [
    "Alaïmia",
    "Aouf",
    "Aïn Fares",
    "Aïn Fekan",
    "Aïn Ferah",
    "Aïn Fras",
    "Beniane",
    "Bou Hanifia",
    "Bou Henni",
    "Chorfa",
    "El Bordj",
    "El Gaada",
    "El Ghomri",
    "El Guettana",
    "El Keurt",
    "El Menaouer",
    "Ferraguig",
    "Froha",
    "Gharrous",
    "Ghriss",
    "Guerdjoum",
    "Hachem",
    "Hacine",
    "Khalouia",
    "Makdha",
    "Mamounia",
    "Maoussa",
    "Mascara",
    "Matemore",
    "Mocta Douz",
    "Mohammadia",
    "Nesmoth",
    "Oggaz",
    "Oued El Abtal",
    "Oued Taria",
    "Ras El Aïn Amirouche",
    "Sedjerara",
    "Sehailia",
    "Sidi Abdeldjebar",
    "Sidi Abdelmoumen",
    "Sidi Boussaid",
    "Sidi Kada",
    "Sig",
    "Tighennif",
    "Tizi",
    "Zahana",
    "Zelmata",
  ],
  "30": [
    "Aïn Beida",
    "Hassi Ben Abdellah",
    "Hassi Messaoud",
    "N'Goussa",
    "Ouargla",
    "Rouissat",
    "Sidi Khouiled",
  ],
  "31": [
    "Arzew",
    "Aïn El Bia",
    "Aïn El Kerma",
    "Aïn El Turk",
    "Ben Freha",
    "Bethioua",
    "Bir El Djir",
    "Bou Sfer",
    "Boufatis",
    "Boutlelis",
    "El Ançor",
    "El Braya",
    "El Kerma",
    "Es Senia",
    "Gdyel",
    "Hassi Ben Okba",
    "Hassi Bounif",
    "Hassi Mefsoukh",
    "Marsat El Hadjadj",
    "Mers El Kébir",
    "Misserghin",
    "Oran",
    "Oued Tlelat",
    "Sidi Benyebka",
    "Sidi Chami",
    "Tafraoui",
  ],
  "32": [
    "Arbaouat",
    "Aïn El Orak",
    "Boualem",
    "Bougtoub",
    "Boussemghoun",
    "Brezina",
    "Cheguig",
    "Chellala",
    "El Abiodh Sidi Cheikh",
    "El Bayadh",
    "El Bnoud",
    "El Kheiter",
    "El Mehara",
    "Ghassoul",
    "Kef El Ahmar",
    "Kraakda",
    "Rogassa",
    "Sidi Ameur",
    "Sidi Slimane",
    "Sidi Tifour",
    "Stitten",
    "Tousmouline",
  ],
  "33": [
    "Bordj Omar Driss",
    "Debdeb",
    "Illizi",
    "In Amenas",
  ],
  "34": [
    "Aïn Taghrout",
    "Aïn Tesra",
    "Belimour",
    "Ben Daoud",
    "Bir Kasdali",
    "Bordj Bou Arreridj",
    "Bordj Ghédir",
    "Bordj Zemoura",
    "Colla",
    "Djaafra",
    "El Ach",
    "El Achir",
    "El Anseur",
    "El Hamadia",
    "El M'hir",
    "El Main",
    "Ghilassa",
    "Haraza",
    "Hasnaoua",
    "Khelil",
    "Ksour",
    "Mansoura",
    "Medjana",
    "Ouled Brahem",
    "Ouled Dahmane",
    "Ouled Sidi Brahim",
    "Rabta",
    "Ras El Oued",
    "Sidi Embarek",
    "Taglait",
    "Tassameurt",
    "Tefreg",
    "Teniet En Nasr",
    "Tixter",
  ],
  "35": [
    "Afir",
    "Ammal",
    "Baghlia",
    "Ben Choud",
    "Beni Amrane",
    "Bordj Menaiel",
    "Boudouaou",
    "Boudouaou El Bahri",
    "Boumerdes",
    "Bouzegza Keddara",
    "Chabet el Ameur",
    "Corso",
    "Dellys",
    "Djinet",
    "El Kharrouba",
    "Hammedi",
    "Issers",
    "Khemis El Khechna",
    "Larbatache",
    "Leghata",
    "Naciria",
    "Ouled Aissa",
    "Ouled Hedadj",
    "Ouled Moussa",
    "Si Mustapha",
    "Sidi Daoud",
    "Souk El Had",
    "Taourga",
    "Thenia",
    "Tidjelabine",
    "Timezrit",
    "Zemmouri",
  ],
  "36": [
    "Asfour",
    "Aïn El Assel",
    "Aïn Kerma",
    "Ben Mehidi",
    "Berrihane",
    "Besbes",
    "Bougous",
    "Bouhadjar",
    "Bouteldja",
    "Chebaita Mokhtar",
    "Chefia",
    "Chihani",
    "Dréan",
    "Echatt",
    "El Aioun",
    "El Kala",
    "El Tarf",
    "Hammam Beni Salah",
    "Lac des Oiseaux",
    "Oued Zitoun",
    "Raml Souk",
    "Souarekh",
    "Zerizer",
    "Zitouna",
  ],
  "37": [
    "Oum el Assel",
    "Tindouf",
  ],
  "38": [
    "Ammari",
    "Beni Chaib",
    "Beni Lahcene",
    "Bordj Bou Naama",
    "Bordj El Emir Abdelkader",
    "Boucaid",
    "Khemisti",
    "Larbaa",
    "Lardjem",
    "Layoune",
    "Lazharia",
    "Maacem",
    "Melaab",
    "Ouled Bessem",
    "Sidi Abed",
    "Sidi Boutouchent",
    "Sidi Lantri",
    "Sidi Slimane",
    "Tamalaht",
    "Theniet El Had",
    "Tissemsilt",
    "Youssoufia",
  ],
  "39": [
    "Bayadha",
    "Beni Guecha",
    "Debila",
    "Douar El Ma",
    "El Ogla",
    "El Oued",
    "Guemar",
    "Hamraia",
    "Hassani Abdelkrim",
    "Hassi Khalifa",
    "Kouinine",
    "Magrane",
    "Mih Ouansa",
    "Nakhla",
    "Oued El Alenda",
    "Ourmas",
    "Reguiba",
    "Robbah",
    "Sidi Aoun",
    "Taghzout",
    "Taleb Larbi",
    "Trifaoui",
  ],
  "40": [
    "Aïn Touila",
    "Babar",
    "Baghai",
    "Bouhmama",
    "Chechar",
    "Chelia",
    "Djellal",
    "El Hamma",
    "El Mahmal",
    "El Oueldja",
    "Ensigha",
    "Kais",
    "Khenchela",
    "Khirane",
    "M'Sara",
    "M'Toussa",
    "Ouled Rechache",
    "Remila",
    "Tamza",
    "Taouzient",
    "Yabous",
  ],
  "41": [
    "Aïn Soltane",
    "Aïn Zana",
    "Bir Bou Haouch",
    "Drea",
    "Hanancha",
    "Heddada",
    "Khedara",
    "Khemissa",
    "M'daourouch",
    "Mechroha",
    "Merahna",
    "Oued Keberit",
    "Ouillen",
    "Ouled Driss",
    "Ouled Moumene",
    "Oum El Adhaim",
    "Ragouba",
    "Safel El Ouiden",
    "Sedrata",
    "Sidi Fredj",
    "Souk Ahras",
    "Taoura",
    "Terraguelt",
    "Tiffech",
    "Zaarouria",
    "Zouabi",
  ],
  "42": [
    "Aghbal",
    "Ahmar El Aïn",
    "Attatba",
    "Aïn Tagourait",
    "Beni Milleuk",
    "Bou Ismaïl",
    "Bouharoun",
    "Bourkika",
    "Chaiba",
    "Cherchell",
    "Damous",
    "Douaouda",
    "Fouka",
    "Gouraya",
    "Hadjeret Ennous",
    "Hadjout",
    "Khemisti",
    "Koléa",
    "Larhat",
    "Menaceur",
    "Merad",
    "Messelmoun",
    "Nador",
    "Sidi Amar",
    "Sidi Ghiles",
    "Sidi Rached",
    "Sidi Semiane",
    "Tipaza",
  ],
  "43": [
    "Ahmed Rachedi",
    "Amira Arrès",
    "Aïn Beida Harriche",
    "Aïn Mellouk",
    "Aïn Tine",
    "Benyahia Abderrahmane",
    "Bouhatem",
    "Chelghoum Laid",
    "Chigara",
    "Derradji Bousselah",
    "El Mechira",
    "Elayadi Barbes",
    "Ferdjioua",
    "Grarem Gouga",
    "Hamala",
    "Mila",
    "Minar Zarza",
    "Oued Athmania",
    "Oued Endja",
    "Oued Seguen",
    "Ouled Khalouf",
    "Rouached",
    "Sidi Khelifa",
    "Sidi Merouane",
    "Tadjenanet",
    "Tassadane Haddada",
    "Teleghma",
    "Terrai Bainen",
    "Tessala Lemtaï",
    "Tiberguent",
    "Yahia Beni Guecha",
    "Zeghaia",
  ],
  "44": [
    "Arib",
    "Aïn Benian",
    "Aïn Bouyahia",
    "Aïn Defla",
    "Aïn Lechiekh",
    "Aïn Soltane",
    "Aïn Torki",
    "Bathia",
    "Belaas",
    "Ben Allal",
    "Bir Ould Khelifa",
    "Birbouche",
    "Bordj Emir Khaled",
    "Boumedfaa",
    "Bourached",
    "Djelida",
    "Djemaa Ouled Cheikh",
    "Djendel",
    "El Abadia",
    "El Amra",
    "El Attaf",
    "El Hassania",
    "El Maine",
    "Hammam Righa",
    "Hoceinia",
    "Khemis Miliana",
    "Mekhatria",
    "Miliana",
    "Oued Chorfa",
    "Oued Djemaa",
    "Rouina",
    "Sidi Lakhdar",
    "Tacheta Zougagha",
    "Tarik Ibn Ziad",
    "Tiberkanine",
    "Zeddine",
  ],
  "45": [
    "Assela",
    "Aïn Ben Khelil",
    "Aïn Sefra",
    "Djeniene Bourezg",
    "El Biod",
    "Kasdir",
    "Makman Ben Amer",
    "Mecheria",
    "Moghrar",
    "Naâma",
    "Sfissifa",
    "Tiout",
  ],
  "46": [
    "Aghlal",
    "Aoubellil",
    "Aïn El Arbaa",
    "Aïn Kihal",
    "Aïn Tolba",
    "Aïn Témouchent",
    "Beni Saf",
    "Bouzedjar",
    "Chaabat El Leham",
    "Chentouf",
    "El Amria",
    "El Emir Abdelkader",
    "El Malah",
    "El Messaid",
    "Hammam Bouhadjar",
    "Hassasna",
    "Hassi El Ghella",
    "Oued Berkeche",
    "Oued Sabah",
    "Ouled Boudjemaa",
    "Ouled Kihal",
    "Oulhaça El Gheraba",
    "Sidi Ben Adda",
    "Sidi Boumedienne",
    "Sidi Ouriache",
    "Sidi Safi",
    "Tamzoura",
    "Terga",
  ],
  "47": [
    "Berriane",
    "Bounoura",
    "Dhayet Bendhahoua",
    "El Atteuf",
    "El Guerrara",
    "Ghardaïa",
    "Mansoura",
    "Metlili",
    "Sebseb",
    "Zelfana",
  ],
  "48": [
    "Ammi Moussa",
    "Aïn Rahma",
    "Aïn Tarek",
    "Belassel Bouzegza",
    "Bendaoud",
    "Beni Dergoun",
    "Beni Zentis",
    "Dar Ben Abdellah",
    "Djidioua",
    "El Guettar",
    "El Hamadna",
    "El Hassi",
    "El Matmar",
    "El Ouldja",
    "Had Echkalla",
    "Hamri",
    "Kalaa",
    "Lahlef",
    "Mazouna",
    "Mediouna",
    "Mendes",
    "Merdja Sidi Abed",
    "Ouarizane",
    "Oued El Djemaa",
    "Oued Essalem",
    "Oued Rhiou",
    "Ouled Aiche",
    "Ouled Sidi Mihoub",
    "Ramka",
    "Relizane",
    "Sidi Khettab",
    "Sidi Lazreg",
    "Sidi M'Hamed Ben Ali",
    "Sidi M'Hamed Benaouda",
    "Sidi Saada",
    "Souk El Had",
    "Yellel",
    "Zemmora",
  ],
  "49": [
    "Aougrout",
    "Charouine",
    "Deldoul",
    "Ksar Kaddour",
    "Metarfa",
    "Ouled Aïssa",
    "Ouled Saïd",
    "Talmine",
    "Timimoun",
    "Tinerkouk",
  ],
  "50": [
    "Bordj Badji Mokhtar",
    "Timiaouine",
  ],
  "51": [
    "Besbes",
    "Doucen",
    "Ech Chaïba",
    "Ouled Djellal",
    "Ras El Miaad",
    "Sidi Khaled",
  ],
  "52": [
    "Beni Ikhlef",
    "Béni Abbès",
    "El Ouata",
    "Igli",
    "Kerzaz",
    "Ksabi",
    "Ouled Khoudir",
    "Tabelbala",
    "Tamtert",
    "Timoudi",
  ],
  "53": [
    "Foggaret Ezzaouia",
    "In Ghar",
    "In Salah",
  ],
  "54": [
    "In Guezzam",
    "Tin Zaouatine",
  ],
  "55": [
    "Benaceur",
    "Blidet Amor",
    "El Allia",
    "El Borma",
    "El Hadjira",
    "M'Naguer",
    "Megarine",
    "Nezla",
    "Sidi Slimane",
    "Taibet",
    "Tamacine",
    "Tebesbest",
    "Touggourt",
    "Zaouia El Abidia",
  ],
  "56": [
    "Bordj El Haouas",
    "Djanet",
  ],
  "57": [
    "Djamaa",
    "El M'Ghair",
    "M'Rara",
    "Oum Touyour",
    "Sidi Amrane",
    "Sidi Khellil",
    "Still",
    "Tendla",
  ],
  "58": [
    "El Menia",
    "Hassi Fehal",
    "Hassi Gara",
  ],
};
